import { render, staticRenderFns } from "./CooperationSystemList.vue?vue&type=template&id=3b506b32&scoped=true&lang=pug"
import script from "./CooperationSystemList.vue?vue&type=script&lang=ts"
export * from "./CooperationSystemList.vue?vue&type=script&lang=ts"
import style0 from "./CooperationSystemList.vue?vue&type=style&index=0&id=3b506b32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b506b32",
  null
  
)

export default component.exports